import { useState, createContext } from "react";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { TypographyStyles } from "@/libraries/wpl/foundations/src";
import GlobalFooter from "@/patterns/global-footer/src";
import GlobalNav from "@/patterns/global-nav/src";

import {
    FutureOfTeamwork,
    AtlassianIntelligence,
    CustomerStories,
    GetStartedCTA,
    HeroJiraCTA,
    ScrollPinnedSections,
    TabsAndIntegrationsSections,
    Team24BannerAlert,
    Team24Promo,
    TeamStats,
    TeamTourKoreaBanner
} from "./sections-v2";

export const HeroSelectedTeamIndexContext = createContext<number | undefined>(
    undefined
);

export const HomePageTemplate = () => {
    const isShowTryNowLink: boolean = FeatureGates.getExperimentValue(
        "wac-globalui-team24-globalnav-cta",
        "isShowTryNowLink",
        true
    );

    const [heroSelectedTeamIndex, setHeroSelectedTeamIndex] = useState<
        number | undefined
    >(undefined);

    return (
        <UFOSegment name="home-page-v2">
            <div>
                <Team24BannerAlert />
                <GlobalNav
                    productKey={"home"}
                    isShowTryNowLink={isShowTryNowLink}
                />
                <TeamTourKoreaBanner dataProductKey="home" />
                <TypographyStyles>
                    <HeroSelectedTeamIndexContext.Provider
                        value={heroSelectedTeamIndex}
                    >
                        <HeroJiraCTA
                            heroSelectedTeamIndex={heroSelectedTeamIndex}
                            onSelectHeroTab={(index: number | undefined) =>
                                setHeroSelectedTeamIndex(index)
                            }
                        />
                        <ScrollPinnedSections />
                        <AtlassianIntelligence />
                        <TeamStats />
                        <TabsAndIntegrationsSections
                            heroSelectedTeamIndex={heroSelectedTeamIndex}
                        />
                        <CustomerStories />
                        <Team24Promo />
                        <FutureOfTeamwork />
                        <GetStartedCTA />
                    </HeroSelectedTeamIndexContext.Provider>
                </TypographyStyles>
                <GlobalFooter />
            </div>
        </UFOSegment>
    );
};
